import { SET_PAIR, ADD_PAIR } from '../config/actionTypes';

const initialState = [];

const PairReducer = (state = initialState, action) => {
	const { data, type } = action;
	switch (type) {
		case SET_PAIR:
			return data;
		case ADD_PAIR:
			return [
				...state,
				data
			];
		default:
			return state;
	}
};

export default PairReducer;
